import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';

import styles from './styles';

const CustomDateInputs = ({
  startDateString,
  endDateString,
}) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.label}>From</span>
      <input
        className={classes.dateInput} type="text"
        value={startDateString}
        name="startDate"
        disabled
      />
      <span className={classes.label}>to</span>
      <input
        className={classes.dateInput} type="text"
        name="endDate"
        value={endDateString}
        disabled
      />
    </div>
  );
};

CustomDateInputs.propTypes = {
  startDateString: PropTypes.string,
  endDateString: PropTypes.string,
}

export default CustomDateInputs;